import React from 'react';
import PropTypes from 'prop-types';
import { useRouter } from 'next/router';

const Page = ({ header, breadcrumb, content, className }) => {
  const router = useRouter();

  return (
    <main className="main" key={router.asPath}>
      {header}
      {breadcrumb && (
        <nav className="breadcrumb-nav">{breadcrumb}</nav>
      )}
      <div className={`page-content ${className}`}>{content}</div>
    </main>
  );
};

Page.propTypes = {
  header: PropTypes.node,
  breadcrumb: PropTypes.node,
  content: PropTypes.node.isRequired,
  className: PropTypes.string,
};

Page.defaultProps = {
  header: null,
};

export default Page;
